import { PartnerPlatform } from '../interfaces/PartnerPlatform/PartnerPlatform';

export const availablePartnerPlatforms: PartnerPlatform[] = [
  'trendyol',
  'hepsiburada',
  'boyner',
  'n11',
  'pazarama',
];

export const partnerPlatformNameMap: Record<PartnerPlatform, string> = {
  internal: 'Web Sitesi',
  trendyol: 'Trendyol',
  hepsiburada: 'Hepsiburada',
  boyner: 'Boyner',
  n11: 'N11',
  pazarama: 'Pazarama',
};
